import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>
  }
}

export const useGTM = (GTM_ID: string | undefined) => {
  const location = useLocation()

  useEffect(() => {
    if (!GTM_ID) return

    // Перевірка, чи вже вставлений скрипт
    if (document.getElementById('gtm-script')) return

    // Основний GTM скрипт
    const script = document.createElement('script')
    script.id = 'gtm-script'
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${GTM_ID}');
    `
    document.head.appendChild(script)

    // Noscript iframe (опціонально: для доступності можна додати прямо в body)
    const noscript = document.createElement('noscript')
    noscript.id = 'gtm-noscript'
    noscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `
    document.body.appendChild(noscript)

    // Clean up при анмаунті
    return () => {
      script.remove()
      noscript.remove()
    }
  }, [GTM_ID])

  useEffect(() => {
    if (!GTM_ID) return
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'pageview',
      page: location.pathname + location.search,
    })
  }, [GTM_ID, location])
}
